module.exports = __webpack_public_path__ + "assets/data.30ba3671.svg";